import { useEffect, useState } from "react";
import BlogCard from '../components/blog/BlogCard'
import { fetchPageBySlug, getBlogs } from "../api/axios";
import DynamicBreadcrumb from "../components/common/DynamicBreadcrumb";
import Seo from "../components/_App/seo";
import Preloader from "../components/_App/Preloader";

const Blog = () => {
  const [pageData, setPageData] = useState(undefined);
  const [blogs, setBlogs] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 6,
    pageCount: 1,
  });
  const [loading, setLoading] = useState(true);

  const fetchBlogs = async (page = 1) => {
    setLoading(true);
    const res = await getBlogs(page, pagination.pageSize);

    setBlogs(res.blogs);
    setPagination(res.pagination);
    setLoading(false);
  };

  useEffect(() => {
    fetchBlogs(1);
  }, []);

  const handlePageChange = (page) => {
    fetchBlogs(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  const getPageNumbers = () => {
    const { page, pageCount } = pagination;
    const pages = [];

    // Case 1: Initial pages
    if (page <= 3) {
      const end = Math.min(3 + (page - 1), pageCount);
      for (let i = 1; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    }

    // Case 2: Last pages
    if (page >= pageCount - 2) {
      const start = Math.max(
        pageCount - (3 + (pageCount - page - 1)),
        1
      );
      for (let i = start; i <= pageCount; i++) {
        pages.push(i);
      }
      return pages;
    }

    // Case 3: Centered pages
    for (let i = page - 1; i <= page + 1; i++) {
      pages.push(i);
    }

    return pages;
  };

  useEffect(() => {
    fetchPageBySlug("blog").then((data) => {
      setPageData(data ?? null);
    });
  }, []);
  if (pageData === undefined) return <Preloader />;
  return (
    <>
      {pageData && (
        <Seo
          seo={pageData?.seo}
          slug={pageData?.slug}
        />
      )}
      <DynamicBreadcrumb />
      <div className="blog-area ptb-100">
        <div className="container">
          <div className="row gy-4">

            {/* 🔥 Loading */}
            {loading && <p>Loading...</p>}

            {/* 🔥 No Blog Found */}
            {!loading && blogs.length === 0 && (
              <div className="col-12 text-center">
                <h3>No Blog Found</h3>
              </div>
            )}

            {/* 🔥 Blog List */}
            {!loading &&
              blogs.map((blog) => {
                return <BlogCard blog={blog} />;
              })}
          </div>

          {/* 🔥 Pagination Buttons */}
          {pagination.pageCount > 1 && (
            <div className="row mt-5">
              <div className="col-12">
                <div className="blog-pagination-wrapper">
                  <nav className="blog-pagination">

                    {/* First Button */}
                    {pagination.page >= 4 && (
                      <button
                        className="pagination-button first"
                        onClick={() => handlePageChange(1)}
                      >
                        First
                      </button>
                    )}

                    {/* Prev Button */}
                    {pagination.page >= 2 && (
                      <button
                        className="pagination-button prev"
                        onClick={() => handlePageChange(pagination.page - 1)}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                          <path d="M19 18L13 12L19 6M11 18L5 12L11 6"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                        </svg>
                      </button>
                    )}

                    {/* Page Numbers */}
                    <div className="page-numbers">
                      {getPageNumbers().map((pageNum) => (
                        <button
                          key={pageNum}
                          className={`page-button ${pagination.page === pageNum ? "active" : ""
                            }`}
                          onClick={() => handlePageChange(pageNum)}
                        >
                          {pageNum}
                        </button>
                      ))}
                    </div>

                    {/* Next Button */}
                    {pagination.page < pagination.pageCount && (
                      <button
                        className="pagination-button next"
                        onClick={() => handlePageChange(pagination.page + 1)}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                          <path d="M5 18L11 12L5 6M13 18L19 12L13 6"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                        </svg>
                      </button>
                    )}

                    {/* Last Button */}
                    {pagination.page <= pagination.pageCount - 3 && (
                      <button
                        className="pagination-button last"
                        onClick={() => handlePageChange(pagination.pageCount)}
                      >
                        Last
                      </button>
                    )}

                  </nav>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    </>
  )
}

export default Blog
